import React from 'react';
import { FormControl } from 'react-bootstrap';
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import * as AnswersActionCreator from "../../../redux/creators/answers";
import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { getUser, hasPermission } from "../../auth/Auth";
import Note from "./Note";
import { translate } from "../../base/Translation";
import eventManager from "../../base/Events";

const nl2br = require('react-nl2br');

moment.locale("sk");

const DAY_FORMAT = 'DD.MM.YYYY';
const DAY_TIME_FORMAT = 'DD.MM.YYYY    HH:mm';

/*eslint no-restricted-globals: 0 */

class Question extends React.Component {

	constructor(props) {
		super(props);

		this.is_epic_fail = false;
		this.hasAnswer = false;

		// Some shortcuts
		this.red = getUser().role !== 4 ? "red" : "black";

		this.state = {
			showNote: false,
			showInternalNote: false,
			test: this.props.test,
			canEdit: hasPermission("FormFill", this.props.testObj)
		}


	}

	/*
	componentWillReceiveProps(props) {
		if (this.props.question.type === "text") {

			let defaultValue = "";

			if (typeof props.answers[this.props.question.form] !== "undefined" && typeof props.answers[this.props.question.form][this.props.question.id] !== "undefined") {
				defaultValue = props.answers[this.props.question.form][this.props.question.id];
			}
		}
	}
	*/

	onCheckboxChange() {
		if (this.answer.other) {
			this.answer.toggle = true;
			this.selectOtherAnswer(this.answer, this.question, this.form);
		} else {
			this.selectAnswer(this.answer.id, this.question, this.form);
		}

		eventManager.trigger("form_changed", { form: this.form, question: this.question });
	}

	onOtherChange(answer, question, form) {
		if (typeof answer.toggle !== "undefined") {
			answer.toggle = false;
		}
		this.props.selectOtherAnswer(answer, question, form);
		eventManager.trigger("form_changed", { form: this.form, question: this.question });
	}

	onSingleChange(evt) {
		this.selectAnswer(evt.target.value, this.question, this.form);
		eventManager.trigger("form_changed", { form: this.form, question: this.question });
	}

	onDateChange(event, datepicker) {
		let date = datepicker.startDate; // moment object
		this.selectAnswer(date.format(this.format === "date" ? DAY_FORMAT : DAY_TIME_FORMAT), this.question, this.form);
		eventManager.trigger("form_changed", { form: this.form, question: this.question });
	}

	onDate2Change(arg1) {
		this.selectAnswer(arg1.format(this.format === "date" ? DAY_FORMAT : DAY_TIME_FORMAT), this.question, this.form);
		eventManager.trigger("form_changed", { form: this.form, question: this.question });
	}

	renderCheckBoxes() {
		let max_points = 0;
		let achieved_points = 0;
		let irrelevant = false;
		let other = false;
		let hasChecked = false;

		let checkboxes = this.props.possibleAnswers.filter(a => a.question === this.props.question.id).map(function (answer) {

			// Set up answers if no answers in DB aka defaults
			let checked = false;

			if (typeof this.props.answers[this.props.question.form] !== "undefined" && typeof this.props.answers[this.props.question.form][this.props.question.id] !== "undefined") {
				checked = this.props.answers[this.props.question.form][this.props.question.id].indexOf(answer.id) !== -1;

				if (!hasChecked && checked) {
					hasChecked = true;
				}

				// In case of "other" there is object instead of just and ID
				// So look if it's and "other"
				if (!checked) {
					for (let i = 0; i < this.props.answers[this.props.question.form][this.props.question.id].length; i++) {
						let ans = this.props.answers[this.props.question.form][this.props.question.id][i];
						if (typeof ans.id !== "undefined" && ans.id === answer.id) {
							checked = true;

							// This will be later added to the "other" object
							// that is the answer text shown in text input
							answer.text = ans.text;
						}
					}
				}
			}

			irrelevant = answer.id === "irrelevant" && checked && !irrelevant;

			max_points += answer["points"];
			if (checked) {
				achieved_points += answer["points"];
				other = answer.other ? answer : false;
			}

			if (!this.state.canEdit) {
				return (
					<div key={answer.id}>
						<label style={{ fontWeight: checked ? "bold" : "normal" }}>
							<span className={checked ? "glyphicon glyphicon-check" : "glyphicon glyphicon-unchecked"} />
							&nbsp;{answer.name}
						</label>
					</div>
				)
			}

			return (
				<div key={answer.id}>
					<label style={{ fontWeight: checked ? "bold" : "normal" }}>
						<FormControl type="checkbox"
							bsClass="custom-checkbox"
							name={this.props.question.id}
							checked={checked}
							onChange={this.onCheckboxChange.bind({
								selectAnswer: this.props.selectAnswer,
								selectOtherAnswer: this.props.selectOtherAnswer,
								answer,
								question: this.props.question,
								form: this.props.question.form
							})}
						/>
						<span className={checked ? "glyphicon glyphicon-check" : "glyphicon glyphicon-unchecked"} />
						&nbsp;{answer.name}
					</label>
				</div>
			);
		}.bind(this));

		if (achieved_points < max_points && max_points > 0 && this.props.question.required && !irrelevant) {
			this.is_epic_fail = true;
		} else {
			this.is_epic_fail = false;
		}

		if (hasChecked) {
			this.hasAnswer = true;
		} else {
			this.hasAnswer = false;
		}

		return (
			<div className="col-md-6">
				{checkboxes}
				{this.renderOther(other)}
			</div>
		);
	}

	renderRadioButtons() {
		let max_points = 0;
		let achieved_points = 0;
		let irrelevant = false;
		let other = false;
		let hasChecked = false;

		let radios = this.props.possibleAnswers.filter(a => a.question === this.props.question.id).map(function (answer) {

			let checked = false;

			if (typeof this.props.answers[this.props.question.form] !== "undefined" && typeof this.props.answers[this.props.question.form][this.props.question.id] !== "undefined") {
				checked = this.props.answers[this.props.question.form][this.props.question.id] === answer.id;

				if (!hasChecked && checked) {
					hasChecked = true;
				}

				//console.log(this.props.answers[this.props.question.form][this.props.question.id]);

				// In case of "other" there is object instead of just and ID
				// So look if it's and "other"
				if (!checked) {
					let ans = this.props.answers[this.props.question.form][this.props.question.id];
					if (typeof ans.id !== "undefined" && ans.id === answer.id) {
						checked = true;
						answer.text = ans.text;
					}
				}
			}

			// !irrelevant is here to prevent overwriting to false if it's already marked as irrelevnt
			irrelevant = answer.id === "irrelevant" && checked && !irrelevant;

			if (parseInt(answer["points"], 10) > max_points) {
				max_points = answer["points"];
			}

			if (checked) {
				achieved_points += answer["points"];
				other = answer.other ? answer : false;
			}

			if (!this.state.canEdit) {
				return (
					<div key={answer.id}>
						<label style={{ fontWeight: checked ? "bold" : "normal" }}>
							<span className={checked ? "glyphicon glyphicon-check" : "glyphicon glyphicon-unchecked"} />
							&nbsp;{answer.name}
						</label>
					</div>
				)
			}

			return (
				<div key={answer.id}>
					<label style={{ fontWeight: checked ? "bold" : "normal" }}>
						<FormControl type="radio"
							bsClass="custom-checkbox"
							name={this.props.question.id}
							checked={checked}
							onChange={this.onCheckboxChange.bind({
								selectAnswer: this.props.selectAnswer,
								selectOtherAnswer: this.props.selectOtherAnswer,
								answer,
								question: this.props.question,
								form: this.props.question.form
							})}
						/>
						<span className={checked ? "glyphicon glyphicon-check" : "glyphicon glyphicon-unchecked"} />
						&nbsp;{answer.name}
					</label>
				</div>
			)
		}.bind(this));

		if (achieved_points < max_points && max_points > 0 && this.props.question.required && !irrelevant) {
			this.is_epic_fail = true;
		} else {
			this.is_epic_fail = false;
		}

		if (hasChecked) {
			this.hasAnswer = true;
		} else {
			this.hasAnswer = false;
		}

		return (
			<div className="col-md-12">
				{radios}
				{this.renderOther(other)}
			</div>
		);
	}

	renderSelect() {

		let max_points = 0;
		let achieved_points = 0;

		let defaultValue = 0;

		if (typeof this.props.answers[this.props.question.form] !== "undefined" && typeof this.props.answers[this.props.question.form][this.props.question.id] !== "undefined") {
			defaultValue = this.props.answers[this.props.question.form][this.props.question.id];
		}

		let answerText = "";

		let options = this.props.possibleAnswers.filter(a => a.question === this.props.question.id).map(function (answer) {

			if (answer["points"] > max_points) {
				max_points = answer["points"];
			}

			if (parseInt(defaultValue, 10) === parseInt(answer.id, 10)) {
				achieved_points += answer["points"];
				answerText = answer.name;
			}

			return (
				<option key={answer.id} value={answer.id}>{answer.name}</option>
			)
		});

		if (achieved_points < max_points && max_points > 0 && this.props.question.required) {
			this.is_epic_fail = true;
		} else {
			this.is_epic_fail = false;
		}

		if (defaultValue !== 0) {
			this.hasAnswer = true;
		} else {
			this.hasAnswer = false;
		}

		if (!this.state.canEdit) {
			return (
				<div className="col-sm-12 col-md-4">
					<label style={{ fontWeight: "bold", color: (answerText ? "black" : this.red) }}>
						{answerText ? answerText : translate("-- Neuvedené --")}
					</label>
				</div>
			)
		}

		return (
			<div className="col-sm-12 col-md-4">
				<FormControl componentClass="select" defaultValue={defaultValue} name={this.props.question.id} onChange={this.onSingleChange.bind({
					selectAnswer: this.props.selectAnswer,
					question: this.props.question,
					form: this.props.question.form
				})}
				>
					<option defaultValue={0}>{translate("Vyberte")}</option>
					{options}
				</FormControl>
			</div>
		);
	}

	renderTextInput() {

		let defaultValue = "";

		if (typeof this.props.answers[this.props.question.form] !== "undefined" && typeof this.props.answers[this.props.question.form][this.props.question.id] !== "undefined") {
			defaultValue = this.props.answers[this.props.question.form][this.props.question.id];
		}

		if (defaultValue !== "") {
			this.hasAnswer = true;
			this.is_epic_fail = false;
		} else {
			this.hasAnswer = false;
			this.is_epic_fail = true;
		}

		if (!this.state.canEdit) {
			return (
				<div className="col-sm-12 col-md-4">
					<label style={{ fontWeight: "bold", color: (defaultValue ? "black" : this.red) }}>
						{defaultValue ? defaultValue : translate("-- Neuvedené --")}
					</label>
				</div>
			)
		}


		return (
			<div className="col-sm-12 col-md-4">
				<input type="text" name={this.props.question.id}
					defaultValue={defaultValue}
					onBlur={this.onSingleChange.bind({
						selectAnswer: this.props.selectAnswer,
						question: this.props.question,
						form: this.props.question.form
					})}
					className="form-control"
				/>
			</div>
		);
	}

	renderDateInput() {
		let date = moment(new Date(), DAY_FORMAT);

		if (typeof this.props.answers[this.props.question.form] !== "undefined" && typeof this.props.answers[this.props.question.form] !== "undefined") {
			let answers = this.props.answers[this.props.question.form];
			if (typeof answers[this.props.question.id] !== "undefined") {
				date = moment(answers[this.props.question.id], DAY_FORMAT);
			}
		}

		let locale = {
			format: DAY_FORMAT,
			separator: ' - ',
			applyLabel: translate("Vybrať"),
			cancelLabel: translate("Zrušiť"),
			weekLabel: 'W',
			customRangeLabel: translate("Vlastný rozsah"),
			daysOfWeek: moment.weekdaysMin(),
			monthNames: moment.monthsShort(),
			firstDay: moment.localeData().firstDayOfWeek(),
		};

		if (!this.state.canEdit) {
			return (
				<div className="col-sm-12 col-md-4">
					<label style={{ fontWeight: "bold", color: (date ? "black" : this.red) }}>
						{date ? date.format(DAY_FORMAT) : translate("-- Neuvedené --")}
					</label>
				</div>
			)
		}

		return (
			<div className="col-sm-12 col-md-4">
				<DatetimeRangePicker startDate={date} locale={locale} showDropdowns singleDatePicker autoApply={false}
					onApply={this.onDateChange.bind({
						selectAnswer: this.props.selectAnswer,
						question: this.props.question,
						form: this.props.question.form,
						format: "date"
					})} >
					<div className="input-group">
						<input type="text" className="form-control" value={date.format(DAY_FORMAT)} readOnly />
						<span className="input-group-btn">
							<button className="default date-range-toggle btn btn-default">
								<i className="fa fa-calendar" />
							</button>
						</span>
					</div>
				</DatetimeRangePicker>
			</div>
		);
	}

	renderDateTimeInput() {
		let date = moment(new Date(), DAY_TIME_FORMAT);

		if (typeof this.props.answers[this.props.question.form] !== "undefined" && typeof this.props.answers[this.props.question.form] !== "undefined") {
			let answers = this.props.answers[this.props.question.form];
			if (typeof answers[this.props.question.id] !== "undefined") {
				date = moment(answers[this.props.question.id], DAY_TIME_FORMAT);
			}
		}


		let locale = {
			format: DAY_TIME_FORMAT,
			separator: ' - ',
			applyLabel: translate("Vybrať"),
			cancelLabel: translate("Zrušiť"),
			weekLabel: 'W',
			customRangeLabel: translate("Vlastný rozsah"),
			daysOfWeek: moment.weekdaysMin(),
			monthNames: moment.monthsShort(),
			firstDay: moment.localeData().firstDayOfWeek()
		};

		if (!this.state.canEdit) {
			return (
				<div className="col-sm-12 col-md-4">
					<label style={{ fontWeight: "bold", color: (date ? "black" : this.red) }}>
						{date ? date.format(DAY_TIME_FORMAT) : translate("-- Neuvedené --")}
					</label>
				</div>
			)
		}

		return (
			<div className="col-sm-12 col-md-4">
				<style>
					{`.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
						padding-left: 0;
						padding-right: 0;
					}`}
				</style>

				<DatetimeRangePicker startDate={date} locale={locale} timePickerIncrement={5} timePicker timePicker24Hour showDropdowns singleDatePicker
					onApply={this.onDateChange.bind({
						selectAnswer: this.props.selectAnswer,
						question: this.props.question,
						form: this.props.question.form,
						format: "datetime"
					})} >
					<div className="input-group">
						<input type="text" className="form-control" value={date.format(DAY_TIME_FORMAT)} readOnly />
						<span className="input-group-btn">
							<button className="default date-range-toggle btn btn-default">
								<i className="fa fa-calendar" />
							</button>
						</span>
					</div>
				</DatetimeRangePicker>
			</div>
		);
	}

	renderOther(answer) {

		if (!answer) {
			return false;
		}

		if (answer.text) {
			this.hasAnswer = true;
		} else {
			this.hasAnswer = false;
		}

		return (
			<div className="form-group">
				<input type="text"
					className="form-control"
					name={this.props.question.id}
					defaultValue={answer.text}
					onChange={function (evt) {
						answer.text = evt.target.value;
						this.onOtherChange(answer, this.props.question, this.props.question.form);
					}.bind(this)} />
			</div>
		)
	};

	render() {

		let possible_answers = <div />;

		switch (this.props.question.type) {
			case "checkbox":
				possible_answers = this.renderCheckBoxes();
				break;
			case "radio":
				possible_answers = this.renderRadioButtons();
				break;
			case "text":
				possible_answers = this.renderTextInput();
				break;
			case "date":
				possible_answers = this.renderDateInput();
				break;
			case "datetime":
				possible_answers = this.renderDateTimeInput();
				break;
			case "select":
				possible_answers = this.renderSelect();
				break;
			default:
				possible_answers = <div>Not implemented</div>;
		}

		let internal_note_toggler = function () {
			if (this.props.question.note_internal && getUser().role >= 4) {
				return (
					<span className="glyphicon glyphicon-question-sign" onClick={() => { this.setState({ showInternalNote: !this.state.showInternalNote }) }} />
				)
			}

			return "";

		}.bind(this);

		let internal_note = function () {
			if (this.props.question.note_internal && getUser().role >= 4 &&  this.state.showInternalNote) {
				return (
					<div className="row questionnaire__sections__section__groups__group__questions__question__answers" style={{ paddingBottom: "1rem" }}>
						<small className="col-md-12">{nl2br(this.props.question.note_internal)}</small>
					</div>
				)
			}

			return "";

		}.bind(this);


		return (
			<div className="row">
				<div className="questionnaire__sections__section__groups__group__questions__question">
					<div className="questionnaire__sections__section__groups__group__questions__question__name" >
						<strong style={{ color: this.is_epic_fail ? (this.hasAnswer ? this.red : "red") : "inherit", fontWeight: "normal" }}>
							{this.props.qsi}.{this.props.qgi}.{this.props.qi}. {this.props.question.name}
						</strong>
						<span className="glyphicon glyphicon-comment" onClick={(e) => {
							this.setState({ showNote: !this.state.showNote });
						}} />
						{internal_note_toggler()}
					</div>
					{internal_note()}
					<div className="row questionnaire__sections__section__groups__group__questions__question__answers">
						{possible_answers}
					</div>

					<Note
						question={this.props.question.id}
						form={this.props.question.form}
						test={this.props.question.test}
						show={this.state.showNote}
						readOnly={!this.state.canEdit} />

				</div>
			</div>
		);
	}
}


function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		selectAnswer: AnswersActionCreator.selectAnswerAction,
		selectOtherAnswer: AnswersActionCreator.selectOtherAnswerAction
	}, dispatch);
}

export default connect(state => ({ answers: state.answers, possibleAnswers: state.formPossibleAnswers }), matchDispatchToProps)(Question);


// WEBPACK FOOTER //
// ./src/modules/form/view.1/Question.js